import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import dict from '../dictionary';

import ReducedData from '../reducedData.json';
import {
  labelStyle,
  tooltip,
  stroke,
  markers,
  legend,
  responsiveFun,
  lineXaxis,
} from './options';
import trans from '../translations.json';
import { DownloadButton } from './options';
import TotalTable from './casesTotal-table';
import { ButtonGroup } from './buttonGroup/buttonGroup';
const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colors = ['#96b8e9'];

class TotalTest extends Component {
  state = {
    ready: false,
    dates: [],
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.setData();
    }
  }

  setData = () => {
    var covidData = ReducedData.covidData;
    const cData = [...covidData];
    const chartData = cData.filter(
      (item) => item[dict.totaCases] > 0,
    );

    var dates = chartData.map((item) => {
      return [item[dict.reportedDate], item[dict.totaCases]];
    });

    //console.log("casesTotal Dates:", dates);

    this.setState({
      series: [
        {
          name: trans.casesTotal.total[this.props.lang],
          data: dates,
          type: 'area',
        },
      ],

      options: {
        legend: legend,
        tooltip: tooltip,
        stroke: stroke,
        markers: markers,
        responsive: responsiveFun().map((item) => {
          item.options.xaxis = { ...lineXaxis(true) };
          item.options.yaxis.title.text =
            trans.casesTotal.yaxis[this.props.lang];
          return item;
        }),
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          // type: 'area',
          // color: colors,
          zoom: { enabled: true },
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        yaxis: {
          title: {
            text: trans.casesTotal.yaxis[this.props.lang],
          },
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        xaxis: { ...lineXaxis(true) },
        colors: colors,
        fill: {
          opacity: [0.5, 1],
        },
        //markers: markers,
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              type="line"
              height="400px"
              aria-hidden="true"
            />
          );
        case viewModes.table:
          return <TotalTable lang={this.props.lang} />;
        default:
          break;
      }
    };

    return (
      <div id="">
        <p>
          {trans.casesTotal.desc[this.props.lang]}{' '}
          <a href="#where_number" rel="noopener">
            {trans.heatmap.whyNumbersDontMatch[this.props.lang]}
          </a>
        </p>
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default TotalTest;
